"use client";

import { clsx } from "@trydig/ui";
import { addLeadingSlash } from "@trydig/utils";
import { useParams } from "next/navigation";
import { Link } from "@/i18n/routing";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokLink } from "@/storyblok";
import styles from "./Header.module.css";

export interface NavLinkProps {
	section: BlokLink;
}

export const NavLink = ({ section }: NavLinkProps) => {
	const { slug } = useParams<{ slug: string[] }>();

	const isActive = slug
		? addLeadingSlash(slug.join("/")) === sbLink(section.href)?.href!
		: false;

	return (
		<Link
			className={clsx(styles.navLink, isActive && styles.active)}
			href={sbLink(section.href)?.href!}
			aria-label={`Go to ${section.text} section`}
		>
			{section.text}
		</Link>
	);
};
